import { SVGProps } from 'react';
import { useTranslation } from 'next-i18next';
import { Divider, Spacing } from '@zep/ui';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../types';
import { PlanPaymentForeignMethod } from './PlanPaymentMethod/PlanPaymentForeignMethod';
import { PlanDurationSelector } from './PlanDurationSelector';
import { PlanPaymentMethod } from './PlanPaymentMethod';
import { PlanTypeSelector } from './PlanTypeSelector';
export const PlanPaymentForm = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    isKrPayment
  } = usePlanPaymentInfoContext();
  const {
    watch
  } = usePlanPaymentFormContext();
  const planType = watch('planType');
  const maxCcu = watch('maxCcu');
  const planTemplateType = watch('planTemplateType');
  const hidePaymentMethod = !!maxCcu && maxCcu >= 300 && planTemplateType === PlanTemplateType.PRODUCT_SUBSCRIPTION;
  return <div className="flex size-auto min-h-[calc(100vh-64px)] flex-[1.095] justify-end bg-white px-[50px] pb-[130px] pt-[40px]" data-sentry-component="PlanPaymentForm" data-sentry-source-file="PlanPaymentForm.tsx">
      <div className="w-[430px] max-w-[430px]">
        <div className="flex items-center gap-[8px]">
          <BoltFillIconSvg data-sentry-element="BoltFillIconSvg" data-sentry-source-file="PlanPaymentForm.tsx" />
          <h1 className="text-[20px] font-[800] text-gray-900">
            {t('subscription:payment.title', '결제하기')}
          </h1>
        </div>
        <Spacing size={30} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentForm.tsx" />
        <PlanTypeSelector data-sentry-element="PlanTypeSelector" data-sentry-source-file="PlanPaymentForm.tsx" />
        <div style={{
        display: planType === 'enterprise' ? 'none' : 'block'
      }}>
          <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentForm.tsx" />
          <Divider data-sentry-element="Divider" data-sentry-source-file="PlanPaymentForm.tsx" />
          <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentForm.tsx" />
          <PlanDurationSelector data-sentry-element="PlanDurationSelector" data-sentry-source-file="PlanPaymentForm.tsx" />
          <div style={{
          display: hidePaymentMethod ? 'none' : 'block'
        }}>
            {isKrPayment ? <PlanPaymentMethod /> : <PlanPaymentForeignMethod />}
          </div>
        </div>
      </div>
    </div>;
};
const BoltFillIconSvg = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} fill="none" {...props} data-sentry-element="svg" data-sentry-component="BoltFillIconSvg" data-sentry-source-file="PlanPaymentForm.tsx">
    <rect width={20} height={20} y={0.969} fill="url(#bolt)" rx={5.455} data-sentry-element="rect" data-sentry-source-file="PlanPaymentForm.tsx" />
    <path fill="#fff" fillRule="evenodd" d="M10.792 4.937c.25.081.418.314.418.576V9.15h3.03a.606.606 0 0 1 .491.962L9.882 16.78a.606.606 0 0 1-1.096-.357v-3.636h-3.03a.606.606 0 0 1-.49-.962l4.848-6.667a.606.606 0 0 1 .678-.22Z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="PlanPaymentForm.tsx" />
    <defs data-sentry-element="defs" data-sentry-source-file="PlanPaymentForm.tsx">
      <linearGradient id="bolt" x1={0} x2={20} y1={1.683} y2={19.54} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="PlanPaymentForm.tsx">
        <stop stopColor="#588AFF" data-sentry-element="stop" data-sentry-source-file="PlanPaymentForm.tsx" />
        <stop offset={1} stopColor="#A572FF" data-sentry-element="stop" data-sentry-source-file="PlanPaymentForm.tsx" />
      </linearGradient>
    </defs>
  </svg>;